import React, { useEffect, useState, useRef } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
  Tabs,
  Tab,
  Autocomplete,
  Button,
  Paper,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CustomTreeView from "../../Common/Components/CustomTreeView";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import CustomAlert from "../../Common/Components/CustomAlert";

function AddRecipe({
  open,
  onClose,
  recipe,
  categories,
  isNew,
  province,
  images,
}) {
  const [active, setActive] = useState(false);
  const [visibilityActive, setVisibilityActive] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);
  const [videos, setVideos] = useState([]);
  const [indeterminateCheckbox, setIndeterminateCheckbox] = useState([]);
  const [selectedNodes, setSelectedNodes] = useState([]);
  const [noEmplacement, setNoEmplacement] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [videoFilesEn, setVideoFilesEn] = useState();
  const [videoFilesFr, setVideoFilesFr] = useState();
  const [TreeViewProvince, setTreeViewProvince] = useState();
  const isActiveInitialized = useRef(false);
  const [formData, setFormData] = useState({
    active: false,
    nameFr: "",
    nameEn: "",
    category: null,
    ingredientsFr: "",
    ingredientsEn: "",
    decorationsFr: "",
    decorationsEn: "",
    utensilsFr: "",
    utensilsEn: "",
    reducedPortionFr: "",
    reducedPortionEn: "",
    takeAwayFr: "",
    takeAwayEn: "",
    recipeFr: "",
    recipeEn: "",
    Province: [],
    images: [],
    uploadedVideoFr: "",
    uploadedVideoEn: "",
    videoFr: [],
    videoEn: [],
  });
  const [currentImage, setCurrentImage] = useState(null);
  const [mainImage, setMainImage] = useState(null);
  const [additionalImages, setAdditionalImages] = useState([]);
  const [videoFr, setVideoFr] = useState(null);
  const [videoEn, setVideoEn] = useState(null);
  const { t, i18n } = useTranslation(["Recipes"]);
  const [isSaving, setIsSaving] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");

  const userState = useSelector((state) => state.user);

  // Add state for active status if not already present
  const [isActive, setIsActive] = useState(recipe ? recipe.estActif : false);

  useEffect(() => {
    const fetchProvince = async () => {
      try {
        const provinceResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/Localization/GetProvince`,
          {
            method: "GET",
            withCredentials: true,
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userState.token}`,
            },
          }
        );

        const provinceData = await provinceResponse.json();
        TreeProvince(provinceData);
      } catch (e) { }
    };

    fetchProvince();
  }, []);

  // Populate fields when `recipe` changes
  useEffect(() => {

    const initializeForm = async () => {
      if (isNew) {
        setFormData({
          nameFr: "",
          nameEn: "",
          category: null,
          ingredientsFr: "",
          ingredientsEn: "",
          decorationsFr: "",
          decorationsEn: "",
          utensilsFr: "",
          utensilsEn: "",
          reducedPortionFr: "",
          reducedPortionEn: "",
          takeAwayFr: "",
          takeAwayEn: "",
          recipeFr: "",
          recipeEn: "",
          province: [],
          images: [],
          uploadedVideoFr: "",
          uploadedVideoEn: "",
          videoFr: [],
          videoEn: [],
        });

        setVisibilityActive(false);
        setStartDate(null);
        setEndDate(null);
        setUploadedFiles([]);
        setSelectedCategory(null);
        setIsActive(false);
        isActiveInitialized.current = true; // flag initialisation
      } else if (!isNew && recipe) {
        const fetchedVideos = await fetchVideos();

        if (!isActiveInitialized.current && recipe.estActif !== undefined) {
          setIsActive(recipe.estActif || false);
          isActiveInitialized.current = true;
        }

        // Sanitize fields
        const fieldsToSanitize = {
          nameFr: recipe.nomFr,
          nameEn: recipe.nomEn,
          ingredientsFr: recipe.ingredientFr,
          ingredientsEn: recipe.ingredientEn,
          decorationsFr: recipe.decorationFr,
          decorationsEn: recipe.decorationEn,
          utensilsFr: recipe.ustensileFr,
          utensilsEn: recipe.ustensileEn,
          reducedPortionFr: recipe.portionMinFr,
          reducedPortionEn: recipe.portionMinEn,
          takeAwayFr: recipe.emporterFr,
          takeAwayEn: recipe.emporterEn,
          recipeFr: recipe.recetteFr,
          recipeEn: recipe.recetteEn,
        };

        const sanitizedFields = Object.fromEntries(
          Object.entries(fieldsToSanitize).map(([key, value]) => [
            key,
            sanitizeField(value),
          ])
        );

        setFormData((prev) => ({
          ...prev,
          ...sanitizedFields,
          active: recipe.estActif || false,
          category: recipe.idRecetteCategorie
            ? categories.find((cat) => cat.id === recipe.idRecetteCategorie)
            : null,
          images: Array.isArray(images)
            ? images.map((imageObj) => ({
              type: "existing",
              url: imageObj.images?.[0] || "",
              format: "image/png",
            }))
            : [],
          videoFr: fetchedVideos?.videoFr
            ? [
              {
                type: "existing",
                url: fetchedVideos.videoFr,
                format: "video/mp4",
              },
            ]
            : [],
          videoEn: fetchedVideos?.videoEn
            ? [
              {
                type: "existing",
                url: fetchedVideos.videoEn,
                format: "video/mp4",
              },
            ]
            : [],
        }));

        setVisibilityActive(!!recipe.dateActivationDebut);
        setStartDate(
          recipe.dateActivationDebut ? dayjs(recipe.dateActivationDebut) : null
        );
        setEndDate(
          recipe.dateActivationFin ? dayjs(recipe.dateActivationFin) : null
        );
        setUploadedFiles(
          recipe.image
            ? [
              {
                type: "existing",
                url: recipe.image,
                format: recipe.formatImage,
              },
            ]
            : []
        );
        setSelectedCategory(
          categories.find((cat) => cat.id === recipe.idRecetteCategorie)
        );
        setMainImage(
          recipe.image
            ? [
              {
                type: "existing",
                url: recipe.image,
                format: recipe.formatImage,
              },
            ]
            : []
        );
        setAdditionalImages(recipe.images || []);
        setVideoFr(recipe.videoFr || []);
        setVideoEn(recipe.videoEn || []);
      }

      if (province) {
        setFormData((prevData) => ({
          ...prevData,
          province: province,
        }));
      }
    };

    initializeForm(); // Appel de la fonction async
  }, [recipe, isNew, categories, images, province]);

  const fetchVideos = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/Recipe/GetVideoByRecipe/${recipe.id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${userState.token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch videos");
      }
      const data = await response.json();
      setVideos(data); // garde l'update de l'état local
      return data; // retourne aussi les données pour les utiliser ailleurs
    } catch (error) {
      console.error("Error fetching videos:", error);
      return null; // pour éviter des erreurs si l'appel échoue
    }
  };

  useEffect(() => {
    // Populate the TreeViewProvince and match selected nodes with province IDs
    const fetchProvince = async () => {
      try {
        const provinceResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/Localization/GetProvince`,
          {
            method: "GET",
            withCredentials: true,
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userState.token}`,
            },
          }
        );

        const provinceData = await provinceResponse.json();
        const treeData = TreeProvince(provinceData);

        // Match the selected provinces by their IDs
        if (province && Array.isArray(province)) {
          const matchedIds = matchProvinceIds(treeData, province);
          setSelectedNodes(Number(matchedIds));
        }
      } catch (e) {
        console.error("Failed to fetch provinces:", e);
      }
    };

    fetchProvince();
  }, [province]); // Run when `province` or tree changes

  useEffect(() => {
    if (province) {
      console.log("Incoming Province Data:", province);

      // Ensure `TreeViewProvince` is already populated
      if (TreeViewProvince && Array.isArray(TreeViewProvince)) {
        // Match province IDs to TreeView nodes
        const matchedIds = matchProvinceIds(TreeViewProvince, province);

        // Set selected nodes
        setSelectedNodes(matchedIds);
      } else {
        console.warn("TreeViewProvince is not populated yet.");
      }
    }
  }, [province, TreeViewProvince]); // Run only when `province` or `TreeViewProvince` changes

  /**
   * Match selected province IDs to the tree structure
   * @param {Array} tree - Tree data structure
   * @param {Array} ids - Array of province IDs
   * @returns {Array} - Array of matching IDs
   */
  const matchProvinceIds = (tree, ids) => {
    const matchedIds = [];

    const traverseTree = (node) => {
      if (ids.includes(node.id)) {
        matchedIds.push(node.id);
      }
      if (node.children) {
        node.children.forEach(traverseTree);
      }
    };

    tree.forEach(traverseTree);
    return matchedIds;
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const sanitizeField = (field) => {
    if (field === null || field === undefined) return "";
    if (typeof field === "string") {
      const val = field.trim().toLowerCase();
      if (val === "null" || val === "undefined") return "";
    }
    return field;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const cleanValue = sanitizeField(value);
    setFormData((prev) => ({ ...prev, [name]: cleanValue }));
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files || []);
    setFormData((prev) => ({
      ...prev,
      images: [...prev.images, ...files],
    }));
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files || []);
    setFormData((prev) => ({
      ...prev,
      images: [...prev.images, ...files],
    }));
  };

  const MAX_FILE_SIZE = 600 * 1024 * 1024; // 99MB to be safe under the 100MB server limit

  const validateAndCompressVideo = async (file) => {
    if (!file) return null;

    console.log(`Validating video: ${file.name}, Size: ${file.size} bytes`);

    if (file.size > MAX_FILE_SIZE) {
      throw new Error(
        `Video file ${file.name} is too large (${(
          file.size /
          (1024 * 1024)
        ).toFixed(2)}MB). Maximum size is ${(
          MAX_FILE_SIZE /
          (1024 * 1024)
        ).toFixed(2)}MB`
      );
    }

    return file;
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      const recetteDTO = new FormData();
      //const isNewRecipe = !recipe?.id;
      const isNewRecipe = isNew;
      // Basic recipe data
      recetteDTO.append("Id", recipe?.id || 0);
      recetteDTO.append("IdRecetteCategorie", selectedCategory?.id || 0);
      recetteDTO.append("NomFr", formData.nameFr);
      recetteDTO.append("NomEn", formData.nameEn);
      recetteDTO.append("IngredientFr", formData.ingredientsFr || null);
      recetteDTO.append("IngredientEn", formData.ingredientsEn || null);
      recetteDTO.append("DecorationFr", formData.decorationsFr || null);
      recetteDTO.append("DecorationEn", formData.decorationsEn || null);
      recetteDTO.append("UstensileFr", formData.utensilsFr || null);
      recetteDTO.append("UstensileEn", formData.utensilsEn || null);
      recetteDTO.append("RecetteFr", formData.recipeFr || null);
      recetteDTO.append("RecetteEn", formData.recipeEn || null);
      recetteDTO.append("PortionMinFr", formData.reducedPortionFr || null);
      recetteDTO.append("PortionMinEn", formData.reducedPortionEn || null);
      recetteDTO.append("EmporterFr", formData.takeAwayFr || null);
      recetteDTO.append("EmporterEn", formData.takeAwayEn || null);
      recetteDTO.append("DateActivationDebut", startDate?.toISOString() || "");
      recetteDTO.append("DateActivationFin", endDate?.toISOString() || "");
      recetteDTO.append("EstActif", isActive);

      // Filter valid provinces and remove duplicates
      const validProvinces = Array.from(
        new Set(
          selectedNodes.filter(
            (id) => id !== null && id !== 0 && Number.isInteger(id)
          )
        )
      );

      console.log("Selected provinces:", validProvinces);

      // Append each province ID individually
      if (validProvinces.length > 0) {
        validProvinces.forEach((id) => {
          recetteDTO.append("Province", id);
        });
      }

      // Add new images
      formData.images.forEach((file, index) => {
        if (file.type !== "existing") {
          recetteDTO.append(`UploadedImages`, file);
        }
      });

      // Add existing images if needed
      const existingImages = formData.images
        .filter((file) => file.type === "existing")
        .map((file) => file.url);

      /*if (existingImages.length > 0) {
        form.append("Images", JSON.stringify(existingImages));
      }*/

      // Handle French video file
      if (formData.videoFr?.[0]?.file) {
        const videoFr = await validateAndCompressVideo(
          formData.videoFr[0].file
        );
        if (videoFr) {
          recetteDTO.append("UploadedVideoFr", videoFr, videoFr.name);
          console.log(
            "Adding French video:",
            videoFr.name,
            videoFr.type,
            videoFr.size
          );
        }
      }

      // Handle English video file
      if (formData.videoEn?.[0]?.file) {
        const videoEn = await validateAndCompressVideo(
          formData.videoEn[0].file
        );
        if (videoEn) {
          recetteDTO.append("UploadedVideoEn", videoEn, videoEn.name);
          console.log(
            "Adding English video:",
            videoEn.name,
            videoEn.type,
            videoEn.size
          );
        }
      }

      // Calculate total form data size
      let totalSize = 0;
      for (let [key, value] of recetteDTO.entries()) {
        if (value instanceof File) {
          totalSize += value.size;
        } else {
          totalSize += new Blob([value.toString()]).size;
        }
      }

      console.log(
        `Total request size: ${(totalSize / (1024 * 1024)).toFixed(2)}MB`
      );

      if (totalSize > MAX_FILE_SIZE) {
        throw new Error(
          `Total request size (${(totalSize / (1024 * 1024)).toFixed(
            2
          )}MB) exceeds maximum allowed size (${(
            MAX_FILE_SIZE /
            (1024 * 1024)
          ).toFixed(2)}MB)`
        );
      }

      const endpoint = isNew ? "AddRecipe" : "EditRecipe";
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/Recipe/${endpoint}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${userState.token}`,
          },
          body: recetteDTO,
          credentials: "include",
        }
      );

      if (!response.ok) {
        // Try to get detailed error message from response
        const errorText = await response.text();
        console.error("Response status:", response.status);
        console.error(
          "Response headers:",
          Object.fromEntries(response.headers)
        );
        console.error("Error details:", errorText);

        throw new Error(
          `Failed to save recipe: ${response.status} - ${errorText}`
        );
      }

      const result = await response.json();
      console.log("Save successful:", result);
      setAlertSeverity("success");
      setAlertMessage(t("RecipeSavedSuccessfully"));
      setAlertOpen(true);

      // Close modal after successful save
      setTimeout(() => {
        onClose();
      }, 2000);
    } catch (error) {
      console.error("Full error object:", error);
      console.error("Error saving recipe:", {
        message: error.message,
        stack: error.stack,
        cause: error.cause,
      });
      setAlertSeverity("error");
      setAlertMessage(t("ErrorSavingRecipe"));
      setAlertOpen(true);
    } finally {
      setIsSaving(false);
    }
  };

  const handleRemoveFile = (type, index = null) => {
    switch (type) {
      case "mainImage":
        setMainImage(null);
        break;
      case "additionalImage":
        setAdditionalImages((prev) => prev.filter((_, i) => i !== index));
        break;
      case "videoFr":
        setVideoFr(null);
        break;
      case "videoEn":
        setVideoEn(null);
        break;
    }
  };

  const TreeProvince = (data) => {
    if (!Array.isArray(data)) {
      console.error("Invalid province data:", data);
      return [];
    }

    const tree = [];
    let ids = 0;

    data.forEach((item) => {
      let country = tree.find((p) => p.paysFr === item.paysFr);
      if (!country) {
        country = {
          id: ids++,
          paysFr: item.paysFr,
          paysEn: item.paysEn,
          children: [],
        };
        tree.push(country);
      }

      let province = country.children.find(
        (p) => p.provinceFr === item.provinceFr
      );
      if (!province) {
        province = {
          id: item.noProvince,
          parent: country.id,
          provinceFr: item.provinceFr,
          provinceEn: item.provinceEn,
          children: [],
        };
        country.children.push(province);
      }
    });

    setTreeViewProvince(tree);
    return tree;
  };

  const handleExpandClick = (event) => {
    // prevent the click event from propagating to the checkbox
    event.stopPropagation();
  };

  const handleNodeSelect = (event, nodeId) => {
    event.stopPropagation();

    if (!Array.isArray(selectedNodes)) {
      setSelectedNodes([]); // Ensure it's an array
    }

    const allChild = getAllChild(nodeId);
    const fathers = getAllFathers(nodeId);

    if (selectedNodes.includes(nodeId)) {
      // Deselect node and its children/fathers
      setSelectedNodes((prev) =>
        prev.filter((id) => !allChild.concat(fathers).includes(id))
      );
    } else {
      // Select node and update parents if needed
      setSelectedNodes((prev) => [...prev, nodeId, ...allChild]);
    }
  };

  // Helper function to handle selecting nodes and updating parents
  const handleSelectNode = (nodeId, allChild, fathers) => {
    const ToBeChecked = [...allChild];
    const ToBeIndeterminate = [];

    fathers.forEach((fatherId) => {
      const fatherNode = bfsSearch(TreeViewProvince, fatherId);

      if (isAllChildrenChecked(fatherNode, ToBeChecked)) {
        ToBeChecked.push(fatherId);
      } else if (isAtLeastOneChildIsChecked(fatherNode, ToBeChecked)) {
        ToBeIndeterminate.push(fatherId);
      }
    });

    setSelectedNodes((prev) => prev.concat(ToBeChecked));
    setIndeterminateCheckbox((prev) => prev.concat(ToBeIndeterminate));

    updateNoEmplacementOnSelect(nodeId, allChild);
  };

  // Handle updating noEmplacement when deselecting
  const updateNoEmplacementOnDeselect = async (nodeId, allChild) => {
    const nodeData = bfsSearch(TreeViewProvince, nodeId);

    if (allChild.length > 1) {
      let leafNodes = [];
      getLeafNoEmplacement(leafNodes, nodeData);
      const diff = noEmplacement.filter((x) => !leafNodes.includes(x));
      await setNoEmplacement(diff);
    } else {
      await setNoEmplacement((prev) =>
        prev.filter((p) => p !== nodeData.noEmplacement)
      );
    }
  };

  // Handle updating noEmplacement when selecting
  const updateNoEmplacementOnSelect = async (nodeId, allChild) => {
    const nodeData = bfsSearch(TreeViewProvince, nodeId);

    if (allChild.length > 1) {
      let leafNodes = [];
      getLeafNoEmplacement(leafNodes, nodeData);

      const diff = leafNodes.filter((x) => !noEmplacement.includes(x));
      await setNoEmplacement((prev) => prev.concat(diff));
    } else {
      await setNoEmplacement((prev) => prev.concat(nodeData.noEmplacement));
    }
  };

  function getLeafNoEmplacement(leafNodes, obj) {
    if (obj.children) {
      obj.children.forEach(function (child) {
        getLeafNoEmplacement(leafNodes, child);
      });
    } else {
      leafNodes.push(obj.noEmplacement);
    }
  }

  const bfsSearch = (graph, targetId) => {
    const queue = [...graph];

    while (queue.length > 0) {
      const currNode = queue.shift();
      if (currNode.id === targetId) {
        return currNode;
      }
      if (currNode.children) {
        queue.push(...currNode.children);
      }
    }
    return []; // Target node not found
  };

  const getAllChild = (id) => {
    return getAllIds(bfsSearch(TreeViewProvince, id));
  };

  const getAllFathers = (id, list = []) => {
    const node = bfsSearch(TreeViewProvince, id);
    list.push(node.parent);
    if (node.parent) {
      return getAllFathers(node.parent, list);
    }
    return list;
  };

  function isAllChildrenChecked(node, test) {
    const leafChild = [];
    getLeafNodes(leafChild, node);

    const nodeIdIndex = leafChild.indexOf(node.id);
    leafChild.splice(nodeIdIndex, 1);

    for (let i = 0; i < leafChild.length; i++) {
      if (test.indexOf(leafChild[i].id) === -1) {
        return false;
      }
    }
    return true;
  }

  function isAtLeastOneChildIsChecked(node, list) {
    const allChild = getAllChild(node.id);
    for (let i = 0; i < allChild.length; i++) {
      if (list.includes(allChild[i])) {
        return true;
      }
    }
    return false;
  }

  function getLeafNodes(leafNodes, obj) {
    if (obj.children) {
      obj.children.forEach(function (child) {
        getLeafNodes(leafNodes, child);
      });
    } else {
      leafNodes.push(obj);
    }
  }

  function getAllIds(node, idList = []) {
    idList.push(node.id);
    if (node.children) {
      node.children.forEach((child) => getAllIds(child, idList));
    }
    return idList;
  }

  useEffect(() => {
    if (images) {
      setCurrentImage(images);
    }
  }, [images]);

  const handleRemoveImage = (index) => {
    setFormData((prev) => ({
      ...prev,
      images: prev.images.filter((_, i) => i !== index),
    }));
  };

  const handleReplaceImage = (e) => {
    if (e.target.files && e.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setCurrentImage(e.target.result);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleVideoChange = (lang, event) => {
    const files = Array.from(event.target.files || []);
    setFormData((prev) => ({
      ...prev,
      [lang === "FR" ? "videoFr" : "videoEn"]: files.map((file) => ({
        type: "new",
        file,
        url: URL.createObjectURL(file),
      })),
    }));
  };

  const handleRemoveVideo = async (lang) => {
    // Demande de confirmation avant suppression
    const confirmDelete = window.confirm(
      `Êtes-vous sûr de vouloir supprimer la vidéo ${lang} ? Cette action est irréversible.`
    );
    if (!confirmDelete) return;

    try {
      // Appel API pour supprimer la vidéo sur le serveur
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/Recipe/DeleteRecipeVideo/${recipe.id}/${lang}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${userState.token}`,
          },
          credentials: "include",
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Erreur lors de la suppression: ${errorText}`);
      }

      // Mettre à jour l’état local (supprime la vidéo du formulaire)
      setFormData((prev) => ({
        ...prev,
        [lang === "FR" ? "videoFr" : "videoEn"]: [],
      }));

      // Facultatif : message de succès
      //alert(`Vidéo ${lang} supprimée avec succès.`);
      setAlertSeverity("success");
      setAlertMessage(`Vidéo ${lang} supprimée avec succès.`);
      setAlertOpen(true);
    } catch (error) {
      console.error("Erreur lors de la suppression de la vidéo :", error);

      // ❌ Message erreur
      setAlertSeverity("error");
      setAlertMessage("Une erreur est survenue lors de la suppression de la vidéo.");
      setAlertOpen(true);
      //alert("Une erreur est survenue lors de la suppression de la vidéo.");
    }
  };


  // Add reorder function
  const reorderImages = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  // Add drag end handler
  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const reorderedImages = reorderImages(
      formData.images,
      result.source.index,
      result.destination.index
    );

    setFormData((prev) => ({
      ...prev,
      images: reorderedImages,
    }));
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth="xl"
        fullWidth
        disableEscapeKeyDown // Prevents closing with Escape key
        onClose={(event, reason) => {
          // Prevent closing by clicking outside
          if (reason === "backdropClick") {
            return;
          }
        }}
      >
        <DialogTitle>
          {recipe?.id ? t("EditRecipe") : t("AddRecipe")}
        </DialogTitle>
        <DialogContent>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box sx={{ p: 2 }}>
              {/* Checkboxes */}
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isActive}
                      onChange={(e) => setIsActive(e.target.checked)}
                    />
                  }
                  label={t("IsActive")}
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={visibilityActive}
                      onChange={(e) => setVisibilityActive(e.target.checked)}
                    />
                  }
                  label="Activer la période de visibilité"
                />
              </Box>

              {/* Date Picker Section */}
              {visibilityActive && (
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}
                >
                  <Typography>Du</Typography>
                  <DatePicker
                    label={t("StartDate")}
                    value={startDate}
                    onChange={(date) => setStartDate(date)}
                    renderInput={(params) => (
                      <TextField {...params} size="small" />
                    )}
                  />
                  <Typography>au</Typography>
                  <DatePicker
                    label={t("EndDate")}
                    value={endDate}
                    onChange={(date) => setEndDate(date)}
                    renderInput={(params) => (
                      <TextField {...params} size="small" />
                    )}
                  />
                </Box>
              )}

              {/* Tabs */}
              <Tabs value={tabIndex} onChange={handleTabChange} sx={{ mb: 2 }}>
                <Tab label="Information" />
                <Tab label="Recette" />
                <Tab label="Portion réduite" />
                <Tab label="Emporter" />
                <Tab label="Ingrédient" />
                <Tab label="Décoration" />
                <Tab label="Vaisselle" />
                <Tab label="Location" />
              </Tabs>

              {/* Tab Content */}
              <Box>
                {tabIndex === 0 && (
                  <>
                    <Box>
                      <TextField
                        name="nameFr"
                        label="Nom en français"
                        fullWidth
                        margin="normal"
                        value={formData.nameFr}
                        onChange={handleInputChange}
                      />
                      <TextField
                        name="nameEn"
                        label="Nom en anglais"
                        fullWidth
                        margin="normal"
                        value={formData.nameEn}
                        onChange={handleInputChange}
                      />
                      <Autocomplete
                        options={categories}
                        getOptionLabel={(option) =>
                          userState.lang == "EN" ? option.textEn : option.textFr
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Recipe Category"
                            fullWidth
                            margin="normal"
                          />
                        )}
                        value={selectedCategory}
                        onChange={(event, value) => setSelectedCategory(value)}
                      />
                    </Box>
                    {/* Upload Buttons and Preview Section */}
                    <Box sx={{ mt: 2 }}>
                      {/* Upload Buttons Row */}
                      <Box
                        sx={{
                          display: "flex",
                          gap: 2,
                          mb: 2,
                          alignItems: "center",
                        }}
                      >
                        {/* Image Upload */}
                        <Box
                          sx={{
                            border: "2px dashed #ccc",
                            borderRadius: 2,
                            p: 2,
                            textAlign: "center",
                            backgroundColor: "#fafafa",
                            flex: 1,
                            cursor: "pointer",
                            "&:hover": {
                              backgroundColor: "#f0f0f0",
                            },
                          }}
                          onDrop={handleDrop}
                          onDragOver={(e) => e.preventDefault()}
                          onDragEnter={(e) => e.preventDefault()}
                        >
                          <input
                            type="file"
                            accept="image/*"
                            multiple
                            onChange={handleFileChange}
                            style={{ display: "none" }}
                            id="image-upload-input"
                          />
                          <label
                            htmlFor="image-upload-input"
                            style={{ cursor: "pointer" }}
                          >
                            <Typography variant="body2">
                              Drag and drop photos here, or click to upload
                            </Typography>
                          </label>
                        </Box>

                        {/* Video Upload Buttons */}
                        <Box sx={{ display: "flex", gap: 2 }}>
                          {/* French Video Upload */}
                          <input
                            type="file"
                            accept="video/*"
                            onChange={(e) => handleVideoChange("FR", e)}
                            style={{ display: "none" }}
                            id="video-fr-upload"
                          />
                          <label htmlFor="video-fr-upload">
                            <Button
                              variant="outlined"
                              component="span"
                              startIcon={<CloudUploadIcon />}
                            >
                              Upload Video FR
                            </Button>
                          </label>

                          {/* English Video Upload */}
                          <input
                            type="file"
                            accept="video/*"
                            onChange={(e) => handleVideoChange("EN", e)}
                            style={{ display: "none" }}
                            id="video-en-upload"
                          />
                          <label htmlFor="video-en-upload">
                            <Button
                              variant="outlined"
                              component="span"
                              startIcon={<CloudUploadIcon />}
                            >
                              Upload Video EN
                            </Button>
                          </label>
                        </Box>
                      </Box>

                      {/* Previews Row */}
                      <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable
                          droppableId="droppable"
                          direction="horizontal"
                        >
                          {(provided) => (
                            <Box
                              ref={provided.innerRef}
                              {...provided.droppableProps}
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                gap: 2,
                                alignItems: "flex-start",
                              }}
                            >
                              {/* Images Preview */}
                              {formData.images?.length > 0 &&
                                formData.images.map((file, index) => {
                                  const isExisting = file.type === "existing";
                                  const fileURL =
                                    isExisting && file.url
                                      ? `data:image/png;base64,${file.url}`
                                      : isExisting
                                        ? ""
                                        : URL.createObjectURL(file);

                                  if (!fileURL) return null;

                                  return (
                                    <Draggable
                                      key={`image-${index}`}
                                      draggableId={`image-${index}`}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <Box
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          sx={{
                                            border: "1px solid #ccc",
                                            borderRadius: 4,
                                            padding: 1,
                                            textAlign: "center",
                                            width: 200,
                                            backgroundColor: snapshot.isDragging
                                              ? "#f5f5f5"
                                              : "white",
                                            "&:hover": {
                                              boxShadow: 2,
                                            },
                                          }}
                                        >
                                          <Box sx={{ position: "relative" }}>
                                            <Typography
                                              variant="caption"
                                              sx={{
                                                position: "absolute",
                                                top: 4,
                                                left: 4,
                                                backgroundColor:
                                                  "rgba(0,0,0,0.6)",
                                                color: "white",
                                                padding: "2px 6px",
                                                borderRadius: 1,
                                              }}
                                            >
                                              {index + 1}
                                            </Typography>
                                            <img
                                              src={fileURL}
                                              alt={`Preview ${index + 1}`}
                                              style={{
                                                width: "100%",
                                                height: 150,
                                                objectFit: "contain",
                                                borderRadius: 4,
                                              }}
                                            />
                                          </Box>
                                          <Typography variant="caption">
                                            {isExisting
                                              ? `Image ${index + 1}`
                                              : file.name ||
                                              `Image ${index + 1}`}
                                          </Typography>
                                          <Button
                                            color="error"
                                            size="small"
                                            onClick={() =>
                                              handleRemoveImage(index)
                                            }
                                            fullWidth
                                            sx={{ mt: 1 }}
                                          >
                                            Remove
                                          </Button>
                                        </Box>
                                      )}
                                    </Draggable>
                                  );
                                })}
                              {provided.placeholder}

                              {/* French Video Preview */}
                              {formData.videoFr?.length > 0 &&
                                formData.videoFr.some(
                                  (video) =>
                                    (video.type === "existing" && video.url) ||
                                    (video.type === "new" && video.file)
                                ) &&
                                formData.videoFr.map((video, index) => (
                                  <Box
                                    key={`video-fr-${index}`}
                                    sx={{
                                      border: "1px solid #ccc",
                                      borderRadius: 4,
                                      padding: 1,
                                      textAlign: "center",
                                      width: 200, // Match image width
                                    }}
                                  >
                                    <video
                                      controls
                                      style={{
                                        width: "100%",
                                        height: 150, // Match image height
                                        objectFit: "contain",
                                        borderRadius: 4,
                                      }}
                                      src={
                                        video.type === "existing"
                                          ? `data:video/mp4;base64,${video.url}`
                                          : URL.createObjectURL(video.file)
                                      }
                                    />
                                    <Typography variant="caption">
                                      French Video
                                    </Typography>
                                    <Button
                                      color="error"
                                      size="small"
                                      onClick={() => handleRemoveVideo("FR")}
                                      fullWidth
                                      sx={{ mt: 1 }}
                                    >
                                      Remove
                                    </Button>
                                  </Box>
                                ))}

                              {/* English Video Preview */}
                              {formData.videoEn?.length > 0 &&
                                formData.videoEn.some(
                                  (video) =>
                                    (video.type === "existing" && video.url) ||
                                    (video.type === "new" && video.file)
                                ) &&
                                formData.videoEn.map((video, index) => (
                                  <Box
                                    key={`video-en-${index}`}
                                    sx={{
                                      border: "1px solid #ccc",
                                      borderRadius: 4,
                                      padding: 1,
                                      textAlign: "center",
                                      width: 200, // Match image width
                                    }}
                                  >
                                    <video
                                      controls
                                      style={{
                                        width: "100%",
                                        height: 150, // Match image height
                                        objectFit: "contain",
                                        borderRadius: 4,
                                      }}
                                      src={
                                        video.type === "existing"
                                          ? `data:video/mp4;base64,${video.url}`
                                          : URL.createObjectURL(video.file)
                                      }
                                    />
                                    <Typography variant="caption">
                                      English Video
                                    </Typography>
                                    <Button
                                      color="error"
                                      size="small"
                                      onClick={() => handleRemoveVideo("EN")}
                                      fullWidth
                                      sx={{ mt: 1 }}
                                    >
                                      Remove
                                    </Button>
                                  </Box>
                                ))}
                            </Box>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </Box>
                  </>
                )}
                {tabIndex === 1 && (
                  <Box>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      La recette en francais
                    </Typography>
                    <TextField
                      name="recipeFr"
                      multiline
                      rows={5}
                      fullWidth
                      value={formData.recipeFr}
                      onChange={handleInputChange}
                    />
                    <Typography variant="body2" sx={{ mt: 2, mb: 1 }}>
                      La recette en anglais
                    </Typography>
                    <TextField
                      name="recipeEn"
                      multiline
                      rows={5}
                      fullWidth
                      value={formData.recipeEn}
                      onChange={handleInputChange}
                    />
                  </Box>
                )}
                {tabIndex === 2 && (
                  <Box>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      La portion reduite en francais
                    </Typography>
                    <TextField
                      multiline
                      rows={5}
                      name="reducedPortionFr"
                      fullWidth
                      variant="outlined"
                      value={formData.reducedPortionFr}
                      onChange={handleInputChange}
                    />

                    <Typography variant="body2" sx={{ mt: 2, mb: 1 }}>
                      La portion reduite en anglais
                    </Typography>
                    <TextField
                      multiline
                      name="reducedPortionEn"
                      rows={5}
                      fullWidth
                      variant="outlined"
                      value={formData.reducedPortionEn}
                      onChange={handleInputChange}
                    />
                  </Box>
                )}
                {tabIndex === 3 && (
                  <Box>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      Emporter en francais
                    </Typography>
                    <TextField
                      multiline
                      name="takeAwayFr"
                      rows={5}
                      fullWidth
                      variant="outlined"
                      value={formData.takeAwayFr}
                      onChange={handleInputChange}
                    />

                    <Typography variant="body2" sx={{ mt: 2, mb: 1 }}>
                      Emporter en anglais
                    </Typography>
                    <TextField
                      multiline
                      name="takeAwayEn"
                      rows={5}
                      fullWidth
                      variant="outlined"
                      value={formData.takeAwayEn}
                      onChange={handleInputChange}
                    />
                  </Box>
                )}
                {tabIndex === 4 && (
                  <Box>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      La liste des ingrédients en français (un ingrédient par
                      ligne)
                    </Typography>
                    <TextField
                      multiline
                      rows={5}
                      name="ingredientsFr"
                      fullWidth
                      variant="outlined"
                      value={formData.ingredientsFr}
                      onChange={handleInputChange}
                    />

                    <Typography variant="body2" sx={{ mt: 2, mb: 1 }}>
                      La liste des ingrédients en anglais (un ingrédient par
                      ligne)
                    </Typography>
                    <TextField
                      multiline
                      rows={5}
                      name="ingredientsEn"
                      fullWidth
                      variant="outlined"
                      value={formData.ingredientsEn}
                      onChange={handleInputChange}
                    />
                  </Box>
                )}
                {tabIndex === 5 && (
                  <Box>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      La liste des decorations en français (une decoration par
                      ligne)
                    </Typography>
                    <TextField
                      multiline
                      rows={5}
                      name="decorationsFr"
                      fullWidth
                      variant="outlined"
                      value={formData.decorationsFr}
                      onChange={handleInputChange}
                    />

                    <Typography variant="body2" sx={{ mt: 2, mb: 1 }}>
                      La liste des decorations en anglais (une decoration par
                      ligne)
                    </Typography>
                    <TextField
                      multiline
                      rows={5}
                      fullWidth
                      name="decorationsEn"
                      variant="outlined"
                      value={formData.decorationsEn}
                      onChange={handleInputChange}
                    />
                  </Box>
                )}
                {tabIndex === 6 && (
                  <Box>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      La liste des vaiselles en français (un item par ligne)
                    </Typography>
                    <TextField
                      multiline
                      rows={5}
                      fullWidth
                      name="utensilsFr"
                      variant="outlined"
                      value={formData.utensilsFr}
                      onChange={handleInputChange}
                    />

                    <Typography variant="body2" sx={{ mt: 2, mb: 1 }}>
                      La liste des vaiselles en anglais (un item par ligne)
                    </Typography>
                    <TextField
                      multiline
                      rows={5}
                      name="utensilsEn"
                      fullWidth
                      variant="outlined"
                      value={formData.utensilsEn}
                      onChange={handleInputChange}
                    />
                  </Box>
                )}
                {tabIndex === 7 && (
                  <Box>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      Province
                    </Typography>
                    <Paper sx={{ m: 2 }}>
                      <CustomTreeView
                        TreeViewProvince={TreeViewProvince}
                        handleExpandClick={handleExpandClick}
                        handleNodeSelect={handleNodeSelect}
                        indeterminateCheckbox={indeterminateCheckbox}
                        selectedNodes={
                          Array.isArray(selectedNodes) ? selectedNodes : []
                        }
                        readOnly={false}
                      />
                    </Paper>
                  </Box>
                )}
              </Box>
            </Box>
          </LocalizationProvider>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} variant="outlined" color="secondary">
            {t("Cancel")}
          </Button>
          <Button
            onClick={handleSave}
            variant="contained"
            color="primary"
            disabled={isSaving}
          >
            {isSaving ? <CircularProgress size={24} /> : t("Save")}
          </Button>
        </DialogActions>
      </Dialog>

      <CustomAlert
        open={alertOpen}
        closeMessage={() => setAlertOpen(false)}
        typeMessage={alertSeverity}
        message={alertMessage}
      />
    </>
  );
}

export default AddRecipe;
